export const th = {
    documentTitle: 'HOW2AI',
    languageLabel: 'ไทย',

    landingHeading: 'เป็นผู้เชี่ยวชาญด้าน AI',
    landingBody: [
        'เรียนรู้เครื่องมือ AI พรอมต์',
        'และเวิร์กโฟลว์ที่นำไปใช้ได้จริง สำหรับการทำงาน',
        'ธุรกิจ และชีวิตประจำวัน'
    ],
    toolsCaption: '+ อีกมากมาย',
    subscriptionLabel: 'ตัวเลือกการสมัครสมาชิก',
    priceLine: 'ราคาวันละ 10.70 บาท',
    subscribeCta: 'สมัครเลย',
    customerService: [
        'ศูนย์บริการลูกค้า: หากต้องการข้อมูลเพิ่มเติม กรุณาโทร',
        '02-322-1556 (จ-ศ เวลา 9:00–17:00 น.)'
    ],
    termsLink: 'เงื่อนไขและข้อกำหนด',

    thankYouHeading: 'สมัครสมาชิกสำเร็จ',
    thankYouBody: [
        'ยินดีต้อนรับสู่ HOW2AI',
        'คุณสามารถเริ่มใช้งานได้ทันที'
    ],
    thankYouSummary: [
        {label: 'ค่าบริการ', value: 'วันละ 10.70 บาท'},
        {label: 'ทดลองใช้งาน', value: 'ฟรี 1 วัน'},
        {label: 'การต่ออายุ', value: 'ต่ออายุทุกวันจนกว่าจะยกเลิก'}
    ],
    thankYouCta: 'เริ่มใช้งาน',

    errorHeading: 'เกิดข้อผิดพลาด',
    errorBody: [
        'เราไม่สามารถดำเนินการสมัครสมาชิกของคุณได้',
        'กรุณาลองใหม่อีกครั้ง'
    ],
    errorCta: 'ลองอีกครั้ง',
};
